import React from 'react';
import Button from '@mui/material/Button';
import GridViewRoundedIcon from '@mui/icons-material/GridViewRounded';
import ReorderRoundedIcon from '@mui/icons-material/ReorderRounded';
import { TabPanel, TabContext } from '@mui/lab';
import { ButtonStyle, IconUserStyle, IconCourseStyle } from './style';

export default function UnstyledTabsCustomized({ onclick = () => {}, value = false }) {
  return (
    <TabContext value="0">
      <TabPanel value="0" style={{ display: 'Flex', with: '100%' }}>
        <Button onClick={() => onclick(true)} style={ButtonStyle}>
          <GridViewRoundedIcon style={IconCourseStyle(value)} />
        </Button>
        <Button onClick={() => onclick(false)} style={ButtonStyle}>
          <ReorderRoundedIcon style={IconUserStyle(value)} />
        </Button>
      </TabPanel>
    </TabContext>
  );
}
